import Alert from "../../Alert";
import API from "../../Network/API";
import { isLoaded, isLoading } from "../../TasksModals/actions";

//Verify MainTask
export async function verifyMainTask(dispatch,getUser,mainTaskId,handleClose,handleModalClose, MAINTASK_VERIFY, MAINTASK_VERIFY_FAIL) {
  // console.log(mainTaskId)
    dispatch(isLoading());
    try {
      var response = await API.post("getUpdateSprint.php", {
        crop: getUser.corp,
        userStoryId: mainTaskId,
        action: "verify",
        emp_id: getUser.empId,
      },{},false);
      // console.log(response)
      if(response.status === 'True') {
        Alert("success", MAINTASK_VERIFY)
        handleClose()
      }else if( response.status === "false")
      {
        handleModalClose()
        Alert("warning", MAINTASK_VERIFY_FAIL )
      }else{

      }  
    } catch (error) {
      Alert('error',error.message);
      // handleClose()
    }
    dispatch(isLoaded());
  }